import Vue from "vue"
import App from "./App.vue"
import router from "./router"
import alert from "./utils/alert"

Vue.config.productionTip = false
Vue.prototype.$alert = alert

new Vue({
  router,
  render: h => h(App)
}).$mount("#app")
